var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.$style.item,attrs:{"data-qa":_vm.orgActive ? 'org' : ''}},[_c('list-entry-button',{class:[_vm.$style.button, { [_vm.$style.active]: _vm.orgActive }],attrs:{"caption":_vm.organization.name,"kind":_vm.orgActive ? 'default' : 'blue',"icon":"circle-logo-menu","data-qa":"organization-name"},on:{"click":_vm.changeOrg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }